module.exports = __webpack_public_path__ + "static/media/splitCheck.dd6e8522.png";